/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Keep_WaitingInputs */

const en_mobile_keep_waiting = /** @type {(inputs: Mobile_Keep_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep waiting`)
};

const es_mobile_keep_waiting = /** @type {(inputs: Mobile_Keep_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir esperando`)
};

/**
* | output |
* | --- |
* | "Keep waiting" |
*
* @param {Mobile_Keep_WaitingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_keep_waiting = /** @type {((inputs?: Mobile_Keep_WaitingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Keep_WaitingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_keep_waiting(inputs)
	return en_mobile_keep_waiting(inputs)
});